import { makeStyles, Theme } from "@material-ui/core";

export const useStyles = makeStyles((theme: Theme) => ({
  root: {
    flexGrow: 1,
    display: "flex",
    minHeight: 500,
    "& .MuiDataGrid-row:nth-child(even)": {
      backgroundColor: "rgb(255 255 255)",
    },
    "&.MuiDataGrid-root .MuiDataGrid-cell:focus": {
      outline: "none",
    },
    "& .MuiTypography-colorPrimary": {
      textDecoration: "none !important",
    },
    "& .MuiDataGrid-columnHeaderWrapper": {
      backgroundColor: theme.palette.primary.light,
      color: theme.palette.primary.contrastText,
    },
    "& .MuiDataGrid-columnHeaderWrapper .MuiIconButton-label svg": { color: "rgba(255,255,255,1)" },
    "& .MuiDataGridPremium-pinnedColumns": {
      fontFamily: ["Inter", "Arial", "sans-serif"].join(","),
      fontSize: 12,
      fontWeight: "bold",
      color: "grey",
      paddingTop: 5,
    },
    "& .MuiDataGrid-aggregationColumnHeaderLabel": {
      fontSize: 10,
      fontWeight: 100,
      color: "grey",
      marginTop: "-10px",
      paddingBottom: "6px",
      textTransform: "none",
    },
    "& .MuiDataGrid-footerCell": {
      color: "grey",
    },
  },
  gridContainer: {
    "& .MuiDataGrid-window": {
      overflowX: "auto",
    },
    "& .MuiDataGrid-toolbarContainer, .MuiButton-text": {
      fontFamily: ["Inter", "Arial", "sans-serif"].join(","),
      fontSize: 12,
      fontWeight: "bold",
      color: "grey",
    },
  },
  backdrop: {
    zIndex: theme.zIndex.modal + 1,
    color: "#fff",
  },
  label: {
    marginTop: theme.spacing(1),
    fontSize: 16,
    color: "#0B3C5D",
  },
}));
